import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { ExportService } from 'features/projects/features/export/service/service'

export { ExportService } from 'features/projects/features/export/service/service'

export function useExportService(): ExportService {
  const client = useApiClient()
  return useMemo(() => new ExportService(client), [client])
}
